import type {ReactElement} from 'react';
import type {ControlledListItem3, ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE, ControlledListItemSize} from '@Components/controlled-list/controlled-list.types';
import {ControlledList} from '@Components/controlled-list';
import {ControlledListSeasonalItemType} from '@Components/controlled-list/components/controlled-list-seasonal-item/controlled-list-seasonal-item.types';
import {BrandKitSource} from '@Components/mystuff-brands/brand-kits.types';
import {useActiveBrandId} from '@Hooks/brands/useActiveBrandId';
import {useSortedBrandKitsFromStore} from '@Hooks/brands/useSortedBrandKitsFromStore';

interface BrandsListProps {
  size?: ControlledListItemSize;
  onClick(brandId: string): void;
}

export function BrandsList({size = ControlledListItemSize.SMALL, ...props}: BrandsListProps): ReactElement<any> | null {
  const brands = useSortedBrandKitsFromStore();
  const activeBrandId: string = useActiveBrandId() ?? '';

  const getListItems = (): ControlledListItemType[] => {
    return brands.map((brand) => {
      const listItemProps: ControlledListItem3 = {
        id: brand.brandId,
        text: brand.name,
        isSelected: brand.brandId === activeBrandId,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
        listSize: size,
        onClick: (): void => {
          props.onClick(brand.brandId);
        },
      };

      if (brand.source === BrandKitSource.HALLOWEEN_PROMOTION) {
        return {
          ...listItemProps,
          type: CONTROLLED_LIST_ITEM_TYPE.SEASONAL,
          seasonType: ControlledListSeasonalItemType.HALLOWEEN,
        };
      }

      return listItemProps;
    });
  };

  return <ControlledList scrollIntoViewIfSelected items={getListItems()} className="spacing-m-0" />;
}
